module.exports = __webpack_public_path__ + "static/media/decade-grid-6.8832bc27.png";